import V2 from "./V2/index.js";
import V1 from "./V1/index.js";
class Index {
    rc;
    constructor(rc) {
        this.rc = rc;
    }
    path() {
        return "/rcvideo";
    }
    v1() {
        return new V1(this);
    }
    v2() {
        return new V2(this);
    }
}
export default Index;
